// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__yNL3i"};